import {inject, injectable} from 'inversify';

import type {BNBoundFormApiModel} from '../../../../../api/types/bnrks/models';
import type {QuestionModel} from '../../../Question/Question.model';
import type {AnswerModel} from '../../Answer.model';

import {AnswerFactory} from '../../Answer.factory';

@injectable()
export class AnswerMapperJrpc {
  constructor(
    @inject(AnswerFactory)
    private readonly factory: AnswerFactory,
  ) {}

  mapAnswersToModelsByQuestionId(
    data: BNBoundFormApiModel['answers'],
    questions: QuestionModel[],
  ) {
    const answersByQuestionId = new Map<string, AnswerModel>();

    Object.entries(data).forEach(([questionId, answer]) => {
      const question = questions.find(question => question.id === questionId);

      if (!question) {
        return;
      }

      answersByQuestionId.set(
        question.id,
        this.factory.create({
          question,
          value: answer,
        }),
      );
    });

    return answersByQuestionId;
  }
}
